import { useMemo, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import CustomSelect from 'app/components/CustomSelect';
import { useFormContext } from 'react-hook-form';
import CustomInput from 'app/components/CustomInput';
import { FormFieldValues, TransformedAccountInfo } from 'app/pages/anipay/model/types';
import { useTranslation } from 'react-i18next';

interface Props {
  accounts: TransformedAccountInfo[];
}
const PaymentDetails = (props: Props) => {
  const { t } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
    watch,
    setValue,
    getValues,
    trigger,
  } = useFormContext<FormFieldValues>();
  const { accounts } = props;

  const selectedAccount = watch('account');

  useEffect(() => {
    if (selectedAccount?.value) {
      setValue('comm_account', selectedAccount);
      trigger('comm_account');
    }
  }, [selectedAccount, setValue]);

  const options = useMemo(() => {
    return accounts?.filter(account => account?.value !== getValues('cr_acc_no')) || [];
  }, [accounts]);

  const accountOptions = options?.filter(
    accountOption => accountOption.value !== getValues('account')?.value
  );
  const commAccountOptions = options?.filter(
    accountOption => accountOption.value !== getValues('comm_account')?.value
  );

  return (
    <Grid container spacing={3} sx={{ maxWidth: '670px' }}>
      <Grid item xs={12} md={6}>
        <CustomSelect
          title={t('anipay.outFlowAccount')}
          control={control}
          options={accountOptions}
          rest={{ ...register('account') }}
          noOptionsText='Name'
          placeholder={t('anipay.outFlowAccount')}
          isValid={!!errors.account?.value?.message}
          errorText={errors.account?.value?.message}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CustomSelect
          title={t('anipay.commissionOutFlowAccount')}
          control={control}
          options={commAccountOptions}
          rest={{ ...register('comm_account') }}
          noOptionsText='Name'
          placeholder={t('anipay.commissionOutFlowAccount')}
          isValid={!!errors.comm_account?.value?.message}
          errorText={errors.comm_account?.value?.message}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomInput
          title={t('anipay.price')}
          placeholder={t('anipay.price')}
          rest={{ ...register('amount') }}
          isValid={!!errors.amount?.message}
          errorText={errors.amount?.message}
        />
      </Grid>
    </Grid>
  );
};

export default PaymentDetails;
